module.exports = __webpack_public_path__ + "img/invest3.1e608e6d.jpeg";